module.exports = __webpack_public_path__ + "files/ac5325d23d336f6480c2a4a80c9f85e3.png";